const UUID_REGEX = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g;
const UUID_REPLACEMENT_TOKEN = ':uuid';

export const getUUID = (input: string): string => {
  const result = input.match(UUID_REGEX);
  return result && result.length > 0 ? result[0] : '';
};

export const containsValidUUID = (input: string) => UUID_REGEX.test(input);
export const replaceUUIDs = (input: string) => input.replace(UUID_REGEX, UUID_REPLACEMENT_TOKEN);
